export default "__VITE_PUBLIC_ASSET__d5babd79__"